
<script>
import VueRecaptcha from 'vue-recaptcha';
import Vue from 'vue'
import VModal from 'vue-js-modal'
import VeeValidate from 'vee-validate';
import Datepicker from 'vuejs-datepicker';
import VueSession from 'vue-session'
import 'whatwg-fetch'
import axios from 'axios'
import {config} from '../config'
import  QuizServices  from './services/QuizServices'



Vue.component('Question', require('./question/Question.vue').default);
Vue.component('Countdown', require('../shared/countdown/Countdown.vue').default);
Vue.use(VueSession);
Vue.use(VModal, { dialog: true });

export default {
  name: 'quiz',
 data() {
    return {
      title:null,
      triviaQuestionUrl:null,
      backendErrorMsg:null,
      quizToken:null,
      isLoading:false,
      isFalse:false,

      isSelectQuizCategoryStage:false,
      triviaQuestionStage:false,
      questionStage:false,
      isGoingToTriviaQuestionStage:false,
      resultsStage:false,

      promoId:window.mepaConfig.promoId,
      quizId:window.mepaConfig.quizId,
      triviaQuizId:window.mepaConfig.triviaQuizId,
      
      selectedQuizCats:[],
      questions:[],
      answers:[],
      leaderboardResultSet:[],
      myResult:null,

      currentQuestion:0,
      isTrivia:false,
      result:null,
      quizServices:new QuizServices()
    }
  },
  props:['leaderboard'],
  created() {    
    this.title = window.mepaConfig.title;
    this.isSelectQuizCategoryStage = true;
    if(this.leaderboard){
      this.getLeaderboard();
    }else{
      this.redirectToLandingPageIfNoToken();
    }
  },

  methods:{
    //Error Modal
    showModal(errorText, isRedirectToHome=true) {
      this.$modal.show('dialog', {
        title: 'Error',
        text: errorText,
        buttons: [
          {
            title: 'Close',
            handler: () => {
              this.hideModal();
              if(isRedirectToHome){
                 window.location.href='index.html';
              }
            }
          }
       ]
      })
    },

    hideModal() {
      this.$modal.hide('dialog');
    },
    
    redirectToLandingPageIfNoToken(){
        if(!this.$session.get('token')){
            window.location.href='index.html';
        }
    },

    //SELECT QUIZ CATEGORIES
    isSelectedQuizCat(numPoints, topic){
        let existQuizCat = this.selectedQuizCats.find((o, i) => {
          if (o.topic == topic&&o.point==numPoints) {
            return o; 
          }
        });
        if(existQuizCat){
          return true;
        }else{
          return false;
        }
    },

    selectQuizCat(numPoints, topic){
        let existQuizCat = this.selectedQuizCats.find((o, i) => {
          if (o.topic == topic&&o.point == numPoints) {
            return o; 
          }
        });
        if(existQuizCat){
          let i = this.selectedQuizCats.indexOf(existQuizCat);
          if(i != -1) {
            this.selectedQuizCats.splice(i, 1);
          }
        }else{
          if(this.selectedQuizCats.length<3){
             let newQuizCat = {};
             newQuizCat['point']=numPoints;
             newQuizCat['topic']=topic;
             this.selectedQuizCats.push(newQuizCat);
          }
        }  
    }, 

    getCategoryObj(key, value){
        let obj = {};
        obj['key']= key;
        obj['value'] = value;
        return obj;
    },
    
    //POPULATE JSONs 
    populateCategoryJson(){
       let data={};
       let catData = [];
       this.selectedQuizCats.forEach(categoryField=>{
            let questionCat = [];
            let cat = this.getCategoryObj('point', categoryField.point);
            questionCat.push(cat);
            cat = this.getCategoryObj('topic', categoryField.topic);
            questionCat.push(cat);
            catData.push(questionCat);
       });
       data['promoId'] = this.promoId;
       data['quizId'] = this.quizId;
       data['questions'] = catData;
       return data;
    },
    
    populateTriviaQuestionJson(){
      let data={};
      let catData = [];
      let questionCat = [];
      let cat = this.getCategoryObj('trivia', 'Trivia');
      questionCat.push(cat);
      catData.push(questionCat);
      data['promoId'] = this.promoId;
      data['quizId'] = this.triviaQuizId;
      data['questions'] = catData;
      return data;
    },
    
    populateStartQuizJson(promoId, quizId){
        let obj = {};
        obj['promoId'] = promoId;
        obj['quizId'] = quizId;
        return obj;
    },

    populateFinishQuizJson(quizId){
        let obj={};
        obj['promoId'] = this.promoId;
        obj['quizId'] = quizId;
        obj['token'] = this.quizToken;
        obj['answer'] = this.answers;
        return obj;
    },

    populateAnswerJson(obj){
      let data = {};
      data['key'] = obj.questionId;
      data['value'] = obj.answerId;
      return data;
    },

    populateGenericJson(){
        let obj = {};
        obj['promoId'] = this.promoId;
        return obj;
    },
    
    //API CALLS
    getQuizQuestions(isTrivia = false){
      let data = null;
      if(isTrivia){
          data = this.populateTriviaQuestionJson();
      }else{
        if(this.selectedQuizCats.length==3){
          data = this.populateCategoryJson();
        }else{
          this.showModal(window.mepaConfig.selectCatErr, false);
        }
      }
      if(data){
           this.isLoading = true;
           this.quizServices.getQuestions(this.$session.get('token'), data).then(response => {
              this.isLoading =false;
              if(response.data.success===true){
                   this.questions = response.data.questions; 
                  if(isTrivia){
                    this.currentQuestion = 0;
                    this.getQuizUrl(this.questions);
                  }else{
                    this.startQuiz();
                  }
              }else{
                  if(response.data.message){
                    this.backendErrorMsg = response.data.message;
                  }
                  this.showModal(window.mepaConfig.apiPostErr);
              }
            })
            .catch(e => {
              this.isLoading =false;
              if(e.response){
                this.showModal(window.mepaConfig.apiPostErr);
              }
           });
      }
    },
    
    // for trivia quiz
    getQuizUrl(questions){
        questions.forEach(question=>{
            if(question.url){
                this.triviaQuestionUrl = question.url;
            }              
        });
    },

    //both normal and trivia quiz
    startQuiz() {
      let quizId = null;
      if(this.triviaQuestionStage){
        quizId = this.triviaQuizId;
      }else{
        quizId = this.quizId;
      }
      let data=this.populateStartQuizJson(this.promoId, quizId);
      this.isLoading = true;
      this.quizServices.postStartQuiz(this.$session.get('token'), data).then(response => {
        this.isLoading =false;
        if(response.data.success===true){
            this.isLoading = false;
            this.quizToken = response.data.token;
            this.questionStage = true;
            this.triviaQuestionStage = false;
            this.isSelectQuizCategoryStage = false;
        }else{
             if(response.data.message){
                this.backendErrorMsg = response.data.message;
              }
              this.showModal(window.mepaConfig.apiPostErr);
        }
      })
      .catch(e => {
        this.isLoading =false;
        if(e.response){
          // this.getBackendErrorMsg(e.response);
             this.showModal(window.mepaConfig.apiPostErr);
        }
       
      });
    },

    confirmToTriviaQuiz(){
       this.triviaQuestionStage = false;
       this.questionStage = true;
       this.isTrivia = true;
    },

    handleAnswer(e) {
      if(e){
        this.answers.push(this.populateAnswerJson(e));
      } 
      setTimeout(() => {
        if((this.currentQuestion+1) === this.questions.length) {
          let quizId = null;
          if(this.questions.length==1){
            quizId = this.triviaQuizId;
            this.isTrivia = true;
          }else{
            quizId = this.quizId;
            this.isTrivia = false;
          }
          this.submitAnswers(quizId, this.isTrivia);
          this.questionStage = false;
        } else {
          this.currentQuestion++;
        }
      }, 300);
    },

    handleTimesUp(e){
        this.handleAnswer(null);
    },

    goToTriviaQuiz(){
        this.isGoingToTriviaQuestionStage = false;
        this.triviaQuestionStage = true;
        this.getQuizQuestions(this.triviaQuestionStage);
    },

    getResultPage(){
         this.isGoingToTriviaQuestionStage = false;
         this.resultsStage = true;
         this.getResult();
    },

    submitAnswers(quizId,isTrivia) {
       let data = this.populateFinishQuizJson(quizId);
       this.isLoading = true;
       this.quizServices.postFinishQuiz(this.$session.get('token'), data).then(response => {
          this.isLoading =false;
          if(response.data.success===true){
              this.isLoading = false;
              this.answers = [];
              if(isTrivia){
                this.getResultPage();
              }else{
                this.isGoingToTriviaQuestionStage = true;
              }
          }else{
              if(response.data.message){
                this.backendErrorMsg = response.data.message;
              }
              //this.getBackendErrorMsg(response);
              this.showModal(window.mepaConfig.apiPostErr);
          }
        })
        .catch(e => {
          this.isLoading =false;
          if(e.response){
          // this.getBackendErrorMsg(e.response);
           this.showModal(window.mepaConfig.apiPostErr);
          }
       });
    },
    
    getResult(){
      let data = this.populateGenericJson();
      this.isLoading = true;
      this.quizServices.getQuizResult(this.$session.get('token'), data).then(response => {
          this.isLoading =false;
          if(response.data.success===true){
              this.isLoading = false;
              this.resultsStage = true;
              this.result = response.data.result;
              this.$session.set('myResult',JSON.stringify(response.data.result));
          }else{
               if(response.data.message){
                this.backendErrorMsg = response.data.message;
              }
              this.showModal(window.mepaConfig.apiPostErr);
          }
        })
        .catch(e => {
          this.isLoading =false;
          if(e.response){
          this.showModal(window.mepaConfig.apiPostErr);
          }
       });
    },

    getLeaderboard(){
      let data = this.populateGenericJson();
      this.isLoading = true;
      this.quizServices.getLeaderBoard(this.$session.get('token'), data).then(response => {
          this.isLoading =false;
          if(response.data.success===true){
              this.isLoading = false;
              this.leaderboardResultSet = response.data.resultSet;
              this.myResult = JSON.parse(this.$session.get('myResult'));
          }else{
              if(response.data.message){
                this.backendErrorMsg = response.data.message;
              }
              this.showModal(window.mepaConfig.apiPostErr);
          }
        })
        .catch(e => {
          this.isLoading =false;
          if(e.response){
            this.showModal(window.mepaConfig.apiPostErr);
          }
       });
    },

    //HELPER FUNCTIONS
     async getBackendErrorMsg(response){
        let isExistErrorMsg = false;
          if(response.data){
            if(response.data.errors){
               if(response.data.errors[0]){
                  if(response.data.errors[0].message){
                     isExistErrorMsg = true;
                     this.showModal(response.data.errors[0].message);
                  }
               }
            }
          }
          if(!isExistErrorMsg){
            if(this.backendErrorMsg){
              this.showModal(this.backendErrorMsg);
            }else{
              this.showModal(window.mepaConfig.apiPostErr);
            }    
          }
    },
  }
}
</script>




// WEBPACK FOOTER //
// src/quiz/Quiz.vue